import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { getBetaProgram } from './programs';
import RequireSecureAccess from '../security/RequireSecureAccess';

const RequireBetaAccess = ({ children }) => {
  const { program } = useParams();

  if (!getBetaProgram(program)) {
    return <Navigate to="/access" replace />;
  }

  return <RequireSecureAccess>{children}</RequireSecureAccess>;
};

export default RequireBetaAccess;
